app.controller('exerciseDetail', function ($scope, breakpointsService, loginService) {
    $scope.exerciseDetail = {
        currentMedia: null,
        availableMedia: {
            video: false,
            webgl: false,
            otherPhoto: false,
            gif: false,
            photo: false
        },
        breakpoint: breakpointsService
    };

    if (isMobile.phone && !loginService.isLoggedIn) {
        loginService.redirectToLoginScreen(true, ['exmobredir=1']);
    }
});
